import { FC } from 'react';

import { SearchConsoleUrlInspection } from '@/modules/DomainsApi';

interface Props {
  sitemap: NonNullable<SearchConsoleUrlInspection['indexStatusResult']>['sitemap'] | null;
}

export const SitemapLabel: FC<Props> = ({ sitemap }) => {
  if (sitemap) {
    return (
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        { sitemap.map((el, index) => (
          <li key={ index }>{ el }</li>
        )) }
      </ul>
    );
  } else {
    return <span>Не знайдено відповідних карт сайту</span>;
  }
};
